import { Type } from "@sinclair/typebox";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
export const enrollFreemiumSchema = Type.Object({
    first_name: Type.String(),
    last_name: Type.String(),
    email: Type.String({ format: "email" }),
    phone_number: Type.String(),
    plan_id: Type.String(),
});
export const createFreemium = async ({ userId, data, }) => {
    console.log("Calling createFreemium with:", { userId, data });
    try {
        const response = await api.post(`clients/${userId}/enrollFreemium`, {
            json: data,
        });
        console.log("Successful response from enrollFreemium:", response);
        const responseData = await response.json();
        return responseData;
    }
    catch (error) {
        // ky automatically throws on non-2xx responses
        const freemiumError = error;
        const errorData = await freemiumError.response.json();
        console.log("Error Data from enrollFreemium:", errorData);
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        throw {
            message: errorData.message,
            error: errorData.error,
            status_code: errorData.status_code,
        };
    }
};
export const useEnrollFreemium = ({ mutationConfig, } = {}) => {
    const queryClient = useQueryClient();
    const { onSuccess, ...restConfig } = mutationConfig || {};
    return useMutation({
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["enroll-freemium"],
            });
            onSuccess?.(...args);
        },
        onError: (error) => {
            console.log("Error in useEnrollFreemium:", error);
            // Extract the error message from the API error response
            const message = error?.message || "An unexpected error occurred";
            throw new Error(message);
        },
        ...restConfig,
        mutationFn: createFreemium,
    });
};
//# sourceMappingURL=createEnrollFreemium.js.map